'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');

function _interopNamespaceCompat(e) {
    if (e && typeof e === 'object' && 'default' in e) return e;
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () { return e[k]; }
                });
            }
        });
    }
    n.default = e;
    return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespaceCompat(React);

const Svg20 = (props) => (React__namespace.createElement("svg", Object.assign({ width: 20, height: 21, viewBox: "0 0 20 21", fill: "none" }, props),
    React__namespace.createElement("g", { clipPath: "url(#20_svg__clip0_39877_64209)" },
        React__namespace.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.547 2.378A1.1 1.1 0 0 1 6.1 2.261l8.355 7.184.035.03c.173.149.38.327.536.504.186.212.427.564.427 1.058s-.241.847-.427 1.059a5.5 5.5 0 0 1-.536.504l-.035.03-8.282 7.12a1.1 1.1 0 1 1-1.435-1.668l8.194-7.045L4.664 3.93a1.1 1.1 0 0 1-.117-1.552", fill: props.fillColor, fillOpacity: 0.92 })),
    React__namespace.createElement("defs", null,
        React__namespace.createElement("clipPath", { id: "20_svg__clip0_39877_64209" },
            React__namespace.createElement("rect", { width: 20, height: 20, fill: "white", transform: "translate(0 .995)" })))));

exports.default = Svg20;
//# sourceMappingURL=20.js.map
